/* ==========================================================================
   KITSTERS · RETURNS & REFUNDS - scroll reveal
   Design system §8: fire once via IntersectionObserver at threshold 0.15, then
   unobserve. Only `transform` + `opacity` are animated (the CSS owns both).
   Respects prefers-reduced-motion - the CSS only hides elements inside a
   `no-preference` query, so bailing out here leaves everything visible.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var targets = document.querySelectorAll('.kret [data-kret-reveal]');
    if (!targets.length) return;

    if (REDUCED.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    /* Stagger capped at 4 items per group so a long list never crawls in (§8). */
    targets.forEach(function (el, index) {
      el.style.transitionDelay = (index % 4) * 80 + 'ms';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
